export default __webpack_public_path__ + "a77bee4bda3d4f8d0d85419a8b3c0c1f.svg";